import script from "./CIE10HC.vue?vue&type=script&setup=true&lang=js"
export * from "./CIE10HC.vue?vue&type=script&setup=true&lang=js"

import "./CIE10HC.vue?vue&type=style&index=0&id=c50cb760&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c50cb760"]])

export default __exports__